import { render } from "./IndividualValueCalculator.vue?vue&type=template&id=40291f6c&scoped=true"
import script from "./IndividualValueCalculator.vue?vue&type=script&lang=ts"
export * from "./IndividualValueCalculator.vue?vue&type=script&lang=ts"

import "./IndividualValueCalculator.vue?vue&type=style&index=0&id=40291f6c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-40291f6c"

export default script